/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class NextGenReportScheduleRequestBase {
    __type: string;

    protected setDiscriminator(type: string) {
        this.__type = type;
    }

    getFixupPrototypeFunction() { return NextGenReportScheduleRequestBase.fixupPrototype; }

    static newInstance(model: Partial<NextGenReportScheduleRequestBase>): NextGenReportScheduleRequestBase {
        let obj = Object.assign(new NextGenReportScheduleRequestBase(), model);
        NextGenReportScheduleRequestBase.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<NextGenReportScheduleRequestBase>): NextGenReportScheduleRequestBase {
        if (!model) return null;
        return NextGenReportScheduleRequestBase.newInstance(<NextGenReportScheduleRequestBase> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: NextGenReportScheduleRequestBase) {
        if (!obj) return;

        models.NextGenReportScheduleRequestBase.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: NextGenReportScheduleRequestBase): boolean {
        switch (obj.__type)
        {
            case "FinOpsConsolidatedReportScheduleRequest":
                Object.setPrototypeOf(obj, models.FinOpsConsolidatedReportScheduleRequest.prototype);
                break;
            case "NextGenReportScheduleRequest":
                Object.setPrototypeOf(obj, models.NextGenReportScheduleRequest.prototype);
                break;
        }
        return true; // Tell the caller this is a polymorphic type, it should not overwrite the prototype.
    }

    static getTypeHierarchy(): (typeof NextGenReportScheduleRequestBase)[] {
        return [
            models.FinOpsConsolidatedReportScheduleRequest,
            models.NextGenReportScheduleRequest,
        ];
    }

    fixupFields() {
    }

}
